import Rating from './SwipeRating';
import AirbnbRating from './TapRating';

export { Rating, AirbnbRating }
